import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-yes-no-dynamic-title-message-dialog',
    templateUrl: './yes-no-dynamic-title-message-dialog.component.html',
    styleUrls: ['./yes-no-dynamic-title-message-dialog.component.scss'],
    standalone: false
})
export class YesNoDynamicTitleMessageDialogComponent implements OnInit {
  title="";
  message="";
  yesButton:boolean;
  noButton:boolean;
  cancelButton:boolean;
  yesText:string;
  noText:string;
  cancelText:string;
  constructor(
    public dialogRef: MatDialogRef<YesNoDynamicTitleMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
     this.dialogRef.disableClose = true; 
     this.title=data.title;
     this.message=data.message;
     this.yesButton=data.yesButton
     this.noButton=data.noButton,
     this.cancelButton=data.cancelButton
     this.yesText=data.yesText
     this.noText=data.noText,
     this.cancelText=data.cancelText
    }

  close(): void {
    this.dialogRef.close("No");
  }
 
  ngOnInit(): void {
   // this.canActivate();
  }

  yes(){
    this.dialogRef.close("Yes");
  }
  no(){
    this.dialogRef.close("No");
  }

  cancel(){
    this.dialogRef.close("Cancel");
  }

}
